import { formatDistanceToNow } from "date-fns";

export function timeAgo(date: string | number | Date): string {
  if (!date) return "";
  
  let parsedDate: Date;
  
  try {
    // Handle different date formats
    if (typeof date === "string") {
      // SuperOps specific handling - treat dates as UTC by default
      if (date.includes("T") && !date.includes("Z") && !date.includes("+")) {
        // This is likely a SuperOps date in format "2023-12-15T10:30:00" (no timezone)
        // SuperOps returns dates in UTC, so treat them as UTC
        parsedDate = new Date(date + "Z");
      } else if (date.includes("T") && (date.includes("Z") || date.includes("+"))) {
        // ISO string with timezone info - parse normally
        parsedDate = new Date(date);
      } else {
        // For other string formats, try to parse as local time
        // This handles cases where the date might be in a different timezone
        const timestamp = Date.parse(date);
        if (isNaN(timestamp)) {
          // If parsing fails, try treating it as a local date
          parsedDate = new Date(date + "T00:00:00");
        } else {
          parsedDate = new Date(timestamp);
        }
      }
    } else if (typeof date === "number") {
      // If it's a timestamp, assume it's in milliseconds
      parsedDate = new Date(date);
    } else {
      // If it's already a Date object
      parsedDate = date;
    }
    
    // Validate the date
    if (isNaN(parsedDate.getTime())) {
      return "Invalid date";
    }
    
    // Ensure the date is not in the future (which would cause "in X hours" display)
    const now = new Date();
    if (parsedDate > now) {
      // If the date is in the future, it's likely a timezone issue
      // For SuperOps dates, try treating them as UTC
      if (typeof date === "string" && date.includes("T") && !date.includes("Z")) {
        // This is a SuperOps date - force it to be UTC
        parsedDate = new Date(date + "Z");
      } else {
        // Try to adjust by treating it as a local date
        const dateString = parsedDate.toISOString().split('T')[0];
        parsedDate = new Date(dateString + "T00:00:00");
      }
    }
    
    return formatDistanceToNow(parsedDate, { addSuffix: true });
  } catch (error) {
    console.error("Error parsing date:", date, error);
    return "Invalid date";
  }
}